import ClientAdministrationForm from './ClientAdministrationForm'

export default ClientAdministrationForm
